module.exports = __webpack_public_path__ + "static/media/step-backward.044c89f1.svg";